import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL, S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useTransLayoutSelections } from '@/pages/Onboarding/hooks/useTransLayoutSelections';
import { getImageByHisType } from '@/pages/Paywall/Variants/FastPayTabsMan/utils/getImageBySelection';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import { StoresLinks, SuccessPageStyles } from './OnboardingBased.styles';

const OnboardingBasedVariant: React.FC = () => {
  const { user } = useAccount();
  // const [authToken, setAuthToken] = React.useState<string | null>(null);
  const { his_type } = useTransLayoutSelections();

  // React.useEffect(() => {
  //   const fetchAuthToken = async () => {
  //     const auth = await apiV1GetMeAuthRequest();
  //     setAuthToken(auth.token);
  //   };
  //   fetchAuthToken();
  // }, []);

  const getBackgroundSrc = () => {
    return getImageByHisType(his_type);
  };

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  return (
    <SuccessPageStyles
      background={'purple-gradient'}
      backgroundImage={getBackgroundSrc()}
    >
      <IonContent>
        <div className={'image-container'} />
        <div className="content">
          <OnboardingTitle className="success-payment-title">
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>
          <div className="next-actions">
            <UiTypography
              align="center"
              variant="body-large"
              className="next-action-description"
            >
              Choose the platform
            </UiTypography>
            <StoresLinks>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('appstore')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/appstore.png`}
                  alt="appstore"
                />
              </a>
              <a
                href={downloadingAppLink}
                onClick={() => fireAmplitude('googleplay')}
              >
                <img
                  src={`${S3_BUCKET_URL}/onboarding/googleplay.png`}
                  alt="googleplay"
                />
              </a>
            </StoresLinks>

            {/* {webCampaign.setup.hasWebAppLink && !!authToken && (
              <WebVersionLink>
                <a href={`${WEB_APP_URL}/?auth=${authToken}`} target="_blank">
                  <IonIcon icon={globeOutline} />
                  <UiTypography
                    variant="label-large"
                    color="white"
                    component="span"
                  >
                    Web version
                  </UiTypography>
                </a>
              </WebVersionLink>
            )} */}

            <UiTypography variant="body-large" align="center">
              OR via the link we sent to {user?.email} (check Inbox and Spam
              folders).
            </UiTypography>
          </div>
          <UiTypography
            variant="body-medium"
            className="questions-email"
            align="center"
          >
            If you have any questions - reach us at{' '}
            <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
              {DIALOGUE_SUPPORT_EMAIL}
            </a>
          </UiTypography>
        </div>
      </IonContent>
    </SuccessPageStyles>
  );
};

export default OnboardingBasedVariant;
